import { render, staticRenderFns } from "./BaseMoreDetailsLink.vue?vue&type=template&id=80cde0ce&scoped=true"
import script from "./BaseMoreDetailsLink.vue?vue&type=script&lang=js"
export * from "./BaseMoreDetailsLink.vue?vue&type=script&lang=js"
import style0 from "./BaseMoreDetailsLink.vue?vue&type=style&index=0&id=80cde0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cde0ce",
  null
  
)

export default component.exports